@if(isDeviceConnectMode){
  <div class="export-container">
    <div class="title">{{ "inspectionUpsertDialog.sendData" | translate }}</div>
    <div class="export-message">
      {{
        "inspectionUpsertDialog.includesInspFolders"
          | translate
            : {
                lowerCaseMarkLabel: lowerCaseMarkLabel,
                lowerCaseTitleLabel: lowerCaseTitleLabel
              }
      }}
    </div>
    <evc-button
      icon="upload"
      buttonStyle="accent"
      importance="primary"
      [textContent]="'inspectionUpsertDialog.send' | translate"
      (click)="sendDataForIPLEXG()"
    />
  </div>
}
